import { useForm } from 'react-hook-form';
import { getValidDirtyValues } from 'app/utils/utils';
import { useEffect } from 'react';
import {
  SoundCloudVersionAudioFormProps,
  SoundCloudVersionAudioFormData,
} from './types';
import { LabelVersionDetailsFormData } from '../LabelVersionDetailsForm/types';

export const useSoundCloudVersionAudio = ({
  releaseVersion,
  updateAudioValidations,
  primaryAudio,
  fetchAudioDetailsValidations,
  isAudioReplacing,
  isSyncing,
  primaryAudioFetching,
  audioData,
  replaceAudioVersion,
  updateVersion,
  updateAudioDetails,
}: SoundCloudVersionAudioFormProps) => {
  const primaryAudioDisabled =
    isAudioReplacing || isSyncing || primaryAudioFetching;

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  const defaultValues: SoundCloudVersionAudioFormData = {
    versionTitle: releaseVersion.metadata.versionTitle || '',
    description: releaseVersion.metadata.description || '',
  };

  const form = useForm<SoundCloudVersionAudioFormData>({
    defaultValues,
  });

  const {
    getValues,
    reset,
    formState: { errors, dirtyFields },
  } = form;

  const onSubmit = async () => {
    const versionFieldKeys = ['versionTitle', 'description'];
    const data = getValues();
    const validDirtyValues = getValidDirtyValues<LabelVersionDetailsFormData>(
      errors,
      dirtyFields,
      data
    );

    const dirtyKeys = Object.keys(validDirtyValues);
    if (dirtyKeys.length) {
      const shouldUpdateVersion = dirtyKeys.some(
        (key) => versionFieldKeys.indexOf(key) >= 0
      );
      if (shouldUpdateVersion) {
        reset(data, { keepErrors: true });
        await updateVersion(validDirtyValues);
      }
    }
  };

  return {
    form,
    onSubmit,
    primaryAudio,
    audioData,
    releaseVersion,
    primaryAudioDisabled,
    replaceAudioVersion,
    primaryAudioFetching,
    isAudioReplacing,
    updateAudioDetails,
    updateAudioValidations,
  };
};
